import { SelectOption } from '@touche-lts/panel-ui/dist'
import RootStore  from 'mobx-stores/root-store'
import { TriggerSearchFunc, ActionhistoryTableBase } from 'mobx-stores/utils'
import { ActionHistoryTableStatus } from 'mobx-stores/utils/action-history-table-base/action-history-table-base.types'
import { OrdersPeriodFilter } from 'models'
import { getSelectOptions } from 'utilities'

export class ActionHistoryStore extends ActionhistoryTableBase {
  private rootStore: any

  constructor (rootStore: any) {
    super()
    this.rootStore = rootStore
  }

  // ACTIONS
  public triggerSearch: TriggerSearchFunc = async (options): Promise<void> => {
    const assignedId = JSON.parse(localStorage.getItem('userDetails'))?.id;
    const searchData = await this.rootStore.generalStore.api.actionHistoryApi.getActionHistory(
      assignedId,
      this.ordersFilter,
      { pageQueryParams: this.getPageQueryParams(options?.resetPageNumber) }
    )

    this.handleSearchResult(searchData)
  }

  // COMPUTED
  public get ordersPeriodFilterOptions (): SelectOption<OrdersPeriodFilter>[] {
    return getSelectOptions(OrdersPeriodFilter)
  }

  public get statusTableHeader(): SelectOption<ActionHistoryTableStatus>[] {
    return Object.values(ActionHistoryTableStatus).map(type => ({
      label: this.statusShown(type),
      value: type
    })) 
  }

  // METHODS
  public statusShown(status: string): string {
    return (status.charAt(0).toUpperCase() + status.slice(1)).replace('_', ' ');
  }

}
